import {peakAlert, peakConfirm} from "../../../PeakDialog.js";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import {ZIDXAccountContactSavedListings} from "./AccountContactSavedListings.js";
import jQuery from "jquery";

let $=jQuery.noConflict();

export class ZIDXAccountContactRecommendedListings implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountContactRecommendedListingsContainer";
    }
    render(){
        // console.log("contact recommended listings");
        var savedListings=new ZIDXAccountContactSavedListings(this.zidx);
        savedListings.bindEvents();

        let self=this;
        $(".notifyRecommendedListingsButton", this.zidx.peakidxShadowRoot).off("click").on("click", async function(this, e){
                e.preventDefault();
                if(await peakConfirm("Are you sure you want to send an email to your contact with these recommended listings?")) {
                    if (this instanceof HTMLAnchorElement) {
                        let button = this;

                        let obj = {
                            id: "ajaxNotifyContact",
                            method: "get",
                            postObj: {},
                            ignoreOldRequests: false,
                            callback: function (r: string) {
                                let rs = JSON.parse(r);
                                if (rs.success) {
                                    window.location.href=window.location.href.replace("&message=", "&ztv=")+"&message="+encodeURIComponent("Email sent successfully");
                                } else {
                                    peakAlert(rs.errorMessage);
                                }
                            },
                            errorCallback: function (e: XMLHttpRequest) {
                                console.log(e.status);
                            },
                            url: this.href
                        };
                        self.zidx.ajaxRequest(obj);

                    }
                }
        })
    }
}